import { isPlatformBrowser, isPlatformServer } from '@angular/common';
import { inject, Injectable, PLATFORM_ID } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class CommonClientService {
	private readonly platformId = inject(PLATFORM_ID);

	public readonly isServer = isPlatformServer(this.platformId);
	public readonly isBrowser = isPlatformBrowser(this.platformId);
}
